<template>
  <div>
    <div id="data-list-list-view" class="data-list-container" v-if="dispositivo.has_subscription_active">
      <vx-card title="Zona Segura">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <div class="con-vs-alert con-vs-alert-primary">
              <div class="vs-alert">
                <ol>
                  <li>Clique no botão Editar Zona Segura no mapa.</li>
                  <li class="sm:block md:hidden">Arraste o dedo no mapa e faça um desenho da área que deseja marcar como segura.</li>
                  <li class="sm:hidden md:block">Clique e segure o ponteiro do mouse e faça um desenho da área que deseja marcar como segura.</li>
                  <li>Clique no botão Salvar Zona Segura.</li>
                  <li>Você receberá uma notificação por email todas as vezes que o dispositivo entrar ou sair da zona segura.</li>
                  <li>Para excluir a zona segura e parar de receber notificações, clique no botão Editar Zona Segura e em seguida clique na zona segura (área azul).</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <div v-show="dispositivo.uid && dispositivo.licence.until === null" class="w-full">
              <div class="vx-col w-full h-full prc-2 mb-base">
                <vx-card slot="no-body" class="text-center h-full bg-primary-gradient greet-user">
                  <feather-icon
                    icon="AwardIcon"
                    class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                    svgClasses="h-8 w-8"
                  ></feather-icon>
                  <h1 class="mb-6 text-white">Aviso Importante</h1>
                  <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                    O restante do conteúdo foi bloqueado por sua conta estar na
                    <strong>Versão Gratuita</strong> desbloqueie o conteúdo agora mesmo.
                  </p>
                  <br />
                  <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                    <vs-button color="warning" type="relief">
                      <vs-icon icon-pack="fas" icon="fa-shopping-cart"></vs-icon>&nbsp;Liberar Conteúdo Completo
                    </vs-button>
                  </router-link>
                </vx-card>
              </div>
            </div>

            <l-map :zoom="map.zoom" :center="map.center" style="height: 520px; z-index: 0">
              <l-tile-layer :url="map.url" :attribution="map.attribution" />
              <l-marker :lat-lng="m.pointer" v-for="m in map.markers" :key="m.id">
                <l-tooltip>{{ m.dateTime | formatDateTime }}</l-tooltip>
              </l-marker>
              <l-control position="topleft">
                <vs-button :color="isActive ? 'success' : 'primary'" type="relief" @click="flipActive">
                  {{ isActive ? 'Salvar Zona Segura' : 'Editar Zona Segura' }}
                </vs-button>
              </l-control>
              <l-freedraw v-model="safeZone" :mode="mode" />
            </l-map>
          </div>
        </div>
      </vx-card>
    </div>
    <div v-else-if="dispositivo.uid">
      <mensagem-somente-vip />
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import {NONE, ALL} from 'leaflet-freedraw'
import MensagemSomenteVip from '../components/MensagemSomenteVip.vue'

export default {
  components: {
    MensagemSomenteVip
  },
  data() {
    return {
      processing: false,
      data: [],
      locationLoading: true,
      dispositivo: {
        licence: {
          until: null
        }
      },
      meta: {
        pagination: {
          total_pages: 0
        }
      },
      map: {
        zoom: 16,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '',
        center: L.latLng(0, 0),
        currentCenter: L.latLng(0, 0),
        currentZoom: 16,
        markers: []
      },
      safeZone: [],
      isActive: false
    }
  },

  computed: {
    mode() {
      return this.isActive ? ALL : NONE
    }
  },

  watch: {
    safeZone: function () {
      if (this.safeZone.length > 1) {
        this.safeZone = this.safeZone.splice(0, 1)

        this.$vs.notify({
          color: 'danger',
          title: 'Aviso',
          text:
            'Você só pode ter 1 Zona Segura.'
        })
      }
    }
  },

  mounted() {
    this.load()

    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1
    })
  },

  methods: {
    flipActive() {
      if (this.isActive) {
        this.saveSafeZone()
      }

      this.isActive = !this.isActive
    },
    saveSafeZone() {
      this.processing = true

      this.$api
      .post('/api/v1/mobile/updateSafeZone/' + this.dispositivo.uid, {
        safeZone: this.safeZone
      })
      .then(() => {
        this.$vs.notify({
          time: 6000,
          text: 'Zona Segura salva com sucesso',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      })
      .catch(() => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: 'Erro ao salvar zona segura.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    setLocation(location) {
      let latLng = L.latLng(location.latitude, location.longitude)
      this.map.center = latLng
      this.map.currentCenter = latLng
      this.map.activeMarker = location
    },
    load: function () {
      const mobile = JSON.parse(this.$localStorage.get('mobile'))
      this.$api
      .get(
        `/api/v${mobile.panel_version}/mobile/location/${mobile.uid}?page=1`
      )
      .then((response) => {
        this.locationLoading = false
        this.data = response.data.data
        this.meta = response.data.meta || {pagination: {total_pages: 0}}

        this.map.markers = []

        if (this.data.length) {
          const i = this.data[0]
          this.setLocation(i)

          this.data.forEach((i, idx) => {
            this.map.markers.push({
              address: i.address,
              dateTime: i.datetime,
              pointer: L.latLng(i.latitude, i.longitude),
              icon: L.divIcon({className: 'map-marker', html: idx + 1})
            })
          })
        }
      })

      this.$api.get(`/api/v${mobile.panel_version}/mobile/device/${mobile.uid}`).then((response) => {
        this.dispositivo = response.data.data
        if (this.dispositivo.safe_zone) {
          this.safeZone = [JSON.parse(this.dispositivo.safe_zone)]
        }

        this.$EventBus.$emit('deviceChanged', this.dispositivo)
      })
    }
  }
}
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    @media (max-width: 576px) {
      .vs-table--header {
        margin-left: 0.6rem;
        margin-right: 0.6rem;
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.map-marker {
  width: 30px !important;
  height: 30px !important;
  background: rgba(var(--vs-primary), 1);
  color: #fff;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0px 0px 4px 0px rgba(var(--vs-primary), 1);
}

.td.vs-table--td span {
  cursor: pointer;
}

.pagination .vs-table--content {
  display: none;
}

.data {
  height: 100%;
  overflow: auto;
}

#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
